import React from "react";
import { createPortal } from "react-dom";
import Loader from "../../../components/Loader";

const inputClass =
  "border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 rounded-lg px-3 py-2 text-sm bg-white outline-none transition w-full";
const labelClass = "text-xs font-medium text-slate-700 mb-1";

const AddLocationModal = ({
  show,
  onClose,
  onSave,
  locationName,
  address,
  setLocationName,
  setAddress,
  isEdit,
  isSaving,
}) => {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[100] p-2">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSave();
        }}
        className="bg-white rounded-xl shadow-lg w-full max-w-md max-h-[90vh] flex flex-col overflow-hidden"
      >
        {/* HEADER - cloned from Add Brand modal */}
        <div className="px-6 py-4 bg-[#172554] border-b flex justify-between items-center text-white">
          <h2 className="text-lg font-semibold">
            {isEdit ? "Edit Location" : "Add Location"}
          </h2>
          <button onClick={onClose} type="button" className="text-xl text-white">
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-6 space-y-4 flex-1 overflow-y-auto">
          <div>
            <label className={labelClass}>Location Name</label>
            <input
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
              className={inputClass}
              placeholder="Enter location name"
              autoComplete="off"
            />
          </div>

          <div>
            <label className={labelClass}>Address</label>
            <textarea
              rows={3}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 rounded-lg px-3 py-2 text-sm bg-white outline-none transition w-full"
              placeholder="Enter address"
            />
          </div>
        </div>

        {/* FOOTER - cloned from Add Brand modal */}
        <div className="px-6 py-4 border-t bg-white flex justify-end gap-3">
          <button
            type="submit"
            disabled={isSaving}
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-md transition-colors text-sm flex items-center gap-2 disabled:opacity-60"
          >
            {isSaving ? (
              <Loader text={isEdit ? "Updating..." : "Saving..."} inline />
            ) : (
              isEdit ? "Update Location" : "Save Location"
            )}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold px-6 py-2 rounded-md transition-colors text-sm border border-slate-200"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
};

export default AddLocationModal;
